import React from 'react'
import Functions from './Functions/Functions'
import Preview from '../Preview/Preview'
import About from '../About/About'
import Cashbox from '../Cashbox/Cashbox'
import Basic from '../Basic/Basic'
import Carusel from '../Carusel/Carusel'
import Podxod from '../Podxod/Podxod'
import Contact from '../Contact/Contact'
import Sertificate from '../Sertificate/Sertificate'
import Scaner from '../Scaner/Scaner'

function Main() {

  return (
    <div>
      <Scaner/>
      <Functions />
      <Preview />
      <About />
      <Cashbox />
      <Basic />
      <Carusel />
      <Podxod />
      <Sertificate />
      <Contact />
    </div>
  )
}

export default Main